import React from "react";

import { AppBar, Container, Toolbar } from "@mui/material";

import { LINKS } from "../../../constants";
import Desktop from "./Desktop";
import Mobile from "./Mobile";

const pages = [
  {
    href: LINKS.pricing,
    label: "Pricing",
  },
  { href: LINKS.useCases, label: "Use Cases" },
  {
    href: LINKS.faq,
    label: "FAQ",
  },
];

const Header = () => {
  return (
    <AppBar
      position="fixed"
      sx={{
        backgroundColor: "var(--surface-background)",
        height: { xs: "64px", md: "80px" },
        borderBottom: "none",
        fontFamily: "Poppins",
      }}
    >
      <Container
        maxWidth="xl"
        disableGutters
        sx={{
          height: "100%",
          px: { xs: "8px", md: "60px" },
        }}
      >
        <Toolbar
          disableGutters
          sx={{ height: "100%", minHeight: { xs: "64px", md: "80px" } }}
        >
          <Desktop pages={pages} />
          <Mobile pages={pages} />
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
